import script from "./ResetPass.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetPass.vue?vue&type=script&setup=true&lang=ts"

import "./ResetPass.vue?vue&type=style&index=0&id=7ff8826e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ff8826e"]])

export default __exports__